import React, { useCallback } from 'react';

import { useDispatch } from 'react-redux';

import { setGlobalFilterOpen } from 'app/employer/redux/filter/actions';

import { FilterIcon } from 'app/employer/vectors/index';

const AdminAddFilterSeeData = (props) => {
   const dispatch = useDispatch();

   const handleClick = useCallback((event) => {
      dispatch(setGlobalFilterOpen());
      event.preventDefault();
   });
   return (
      <div className='d-inline-flex align-items-center mt-3'>
         <div className='bg-dark-red rounded p-2 mr-3'><FilterIcon width='18' /></div>
         <div>Please <a className='text-light-blue' href='' onClick={handleClick}><u>add a filter</u></a> to see data.</div>
      </div>
   );
};

export default AdminAddFilterSeeData;
